import { isBrowser } from '@utils/isBrowser';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { drawEntryActions } from '../store/draw-entry';

function cleanupUrl() {
  const url = new URL(window.location.href);

  url.searchParams.delete('dei');
  url.searchParams.delete('setup_intent');
  url.searchParams.delete('setup_intent_client_secret');
  url.searchParams.delete('redirect_status');

  window.history.replaceState(null, '', url.toString());
}

export const usePreAuthDrawIntent = (drawId?: string) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!drawId) return;
    if (!isBrowser()) return;

    const params = new URLSearchParams(window.location.search);

    const dei = params.get('dei');
    const si = params.get('setup_intent');
    const clientSecret = params.get('setup_intent_client_secret');
    const redirectStatus = params.get('redirect_status');
    const hasQueryParams = Boolean(dei && si && clientSecret && redirectStatus);

    if (!hasQueryParams) {
      cleanupUrl();

      return;
    }

    dispatch(
      drawEntryActions.setupDrawEntry({
        actionId: drawId,
        drawEntryIntentId: dei!,
        freshEntry: true,
        entering: true,
        polling: true,
      }),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawId]);
};
